import { render } from "./EditServiceTerms.vue?vue&type=template&id=c439a50e&scoped=true"
import script from "./EditServiceTerms.vue?vue&type=script&lang=js"
export * from "./EditServiceTerms.vue?vue&type=script&lang=js"

import "./EditServiceTerms.vue?vue&type=style&index=0&id=c439a50e&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c439a50e"]])

export default __exports__